module.exports = __webpack_public_path__ + "img/character_resize_sheal.4f80258c.webp";